<template>
    <div class="col-2 bg-white right-sidebar ps-2">

        <div>
            View:

            <div class="form-check">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="Mobile"
                       v-model="viewModel.renderType">
                <label class="form-check-label" for="exampleRadios1">
                    Mobile
                </label>
            </div>
            <div class="form-check">
                <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="Desktop"
                       v-model="viewModel.renderType">
                <label class="form-check-label" for="exampleRadios2">
                    Desktop
                </label>
            </div>
        </div>

        <hr>

        <div>
            <h5>Styles</h5>

            <!-- card/gallery fields -->
            <!--            <field-dropdown-selector :table="table" field-type="Image" :field-wrapper="layout.gallery.data.image"></field-dropdown-selector>-->
            <!--            <field-dropdown-selector :table="table" field-type="Title" :field-wrapper="layout.gallery.data.title"></field-dropdown-selector>-->
            <!--            <field-dropdown-selector :table="table" field-type="Subtitle" :field-wrapper="layout.gallery.data.subTitle"></field-dropdown-selector>-->
            <!--            <field-dropdown-selector :table="table" field-type="Body" :field-wrapper="layout.gallery.data.body"></field-dropdown-selector>-->

            <div v-if="view.view_type === 'gallery'" class="d-flex">

                <div class="me-auto">
                    Columns
                </div>

                <div v-if="viewModel.renderType === 'Mobile'">
                    <i class="far fa-window-maximize fa-2x pointer" @click="onColumnSelected(1)"></i>
                </div>

                <div v-if="viewModel.renderType === 'Mobile'" class="mx-2">
                    <i class="fas fa-columns fa-2x pointer" @click="onColumnSelected(2)"></i>
                </div>

                <div v-if="viewModel.renderType !== 'Mobile'" class="mx-2">
                    <i class="fas fa-th fa-2x pointer" @click="onColumnSelected(3)"></i>
                </div>
            </div>

        </div>

        <hr>

        <div>
            <div class="d-flex">

                <div class="me-auto">
                    <h5>Data</h5>
                </div>

                <div>
                    <router-link :to="{name: 'view-editor', params: {id: this.view.id}}">
                        <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                    </router-link>
                </div>


            </div>

            <row-field-display v-for="(row, index) in layout.rows" :row="row"
                               :key="index + 'RowDisplay'"></row-field-display>
        </div>

        <hr>

        <div v-if="model.app.nav && model.app.nav.tabs && currentTab">

            <div>
                <h5>Tab</h5>
            </div>


            <div>
                <strong>Label:</strong> {{currentTab.label}}
            </div>

            <div class="d-flex">
                <div class="me-auto">
                    <strong>Icon:</strong> {{currentTab.icon}}
                </div>

                <div @click="onIconEditClick" class="pointer">
                    <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                </div>
            </div>

        </div>

        <ionicon-modal v-if="showIoniconModal" @noEvent="showIoniconModal = false" :tab="currentTab" :yes-event="iconSelected"></ionicon-modal>

    </div>
</template>

<script>
    import FieldDropdownSelector from "./FieldDropdownSelector.vue";
    import NavEditor from "../app/NavEditor.vue";
    import RowFieldDisplay from "../../components/RowFieldsDisplay.vue";
    import IoniconModal from "./IoniconModal.vue";
    import AppService from "../../services/AppService";

    export default {
        name: 'LayoutPropertyEditor',
        components: {IoniconModal, RowFieldDisplay, NavEditor, FieldDropdownSelector},
        props: ['layout', 'viewModel', 'table', 'config', 'view'],
        data() {
            return {
                model: webase.model,
                showIoniconModal: false,
                iconSelected: function () {
                }
            }
        },
        computed: {
            currentTab() {
                return this.model.app.nav.tabs.filter(tab => (this.view.id === tab.resource))[0]
            }
        },
        mounted() {
        },
        methods: {
            onColumnSelected(columnCount) {
                console.log('onColumnSelected')
                this.config.columnCount = columnCount
                console.log(this.config.columnCount)
            },
            onIconEditClick() {
                this.showIoniconModal = true

                this.iconSelected = () => {
                    let service = new AppService()
                    let request = {
                        app: this.model.app
                    }

                    service.update(this.model.app.id, request)
                }
            }
        }
    }
</script>

<style>

</style>
